import React from 'react';
import { dummyClick } from '../utilities';

const EpisodePage = ({ children, pageIdx, pagesCount, img, showAddPinCursor, zoom, onClick }) => (
  <div id={`page-${pageIdx+1}`}>
    <div className="a-page-spacer"></div>
    <div className={`a-episode-page w-100 w-80-ns w-75-m t-center ${showAddPinCursor && 'a-cursor-add-pin'}`}
         style={zoom > 100 ? {overflowX: 'scroll'} : {}}
    >
      <div className="relative t-center" style={{ width: zoom+'%' }}>
        <img className="w-100" src={img} onClick={onClick} />
        {children}
      </div>
    </div>
    <p className="white center">{`${pageIdx + 1}/${pagesCount}`}</p>
  </div>
);

EpisodePage.defaultProps = {
  img: '/images/sample_images/sample_jpg.jpg',
  showAddPinCursor: true,
  zoom: 100,
  onClick: dummyClick
};

export default EpisodePage;
